export default __webpack_public_path__ + "static/media/speedplaycard.7de0ced9.png";